import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ReactEcharts from 'echarts-for-react'

/**
 * @description Doughnut chart with the distribution of conversations by attention status
 * (attended / not_attended / not_required).
 * @param {{ data: { attention: { attended:number, not_attended:number, not_required:number } } }} props
 */
// Hex literals: ECharts renders to canvas and cannot resolve CSS custom properties.
// attended green matches --secondary-300 (#69B75C) used across the dashboard.
const ATTENTION_COLOR = {
  attended: '#69B75C',
  not_attended: '#EF4444',
  not_required: '#9CA3AF'
}

function AttentionStatusGraph(props) {
  const { data, height = '100%' } = props
  const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' })

  const option = useMemo(() => {
    const attention = data?.attention
    if (!attention) return

    const keys = ['attended', 'not_attended', 'not_required']

    return {
      tooltip: { trigger: 'item', confine: true },
      legend: { bottom: 0, icon: 'circle' },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: { borderColor: '#fff', borderWidth: 2 },
          label: { show: false },
          data: keys.map((key) => ({
            value: attention[key] || 0,
            name: t(`attentionStatus.${key}`),
            itemStyle: { color: ATTENTION_COLOR[key] }
          }))
        }
      ]
    }
  }, [data, i18n.language])

  return (
    <div className="dashboardView-card dashboard-graph-card">
      <p className="dashboardView-card-title">{t('attentionStatusTitle')}</p>
      {option ? <ReactEcharts option={option} style={{ height }} /> : <p>N/D</p>}
    </div>
  )
}

export default AttentionStatusGraph
